<template>
    <b-card title="Select Month & Year">
        <b-row>
            <b-col md="4">
                <b-form-group>
                Start Date
                <flat-pickr
                    v-model="from"
                    class="form-control"
                />
                </b-form-group>
            </b-col>
                <div class="h1 d-flex align-items-center">-</div>
            <b-col md="4">
                <b-form-group>
                End Date
                <flat-pickr
                    v-model="to"
                    class="form-control"
                />
                </b-form-group>
            </b-col>
            <b-col md="2" class="d-flex align-items-end">
                <b-form-group class="d-flex align-items-end">
                    <b-button @click="resetDate" style="background-color: #96CAEA !important; border:#96CAEA; color: #fff;">
                        Reset
                    </b-button>
                </b-form-group>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
import { 
  BLink, 
  BImg, 
  BContainer, 
  BRow, 
  BCol, 
  BCard, 
  BFormGroup, 
  BButton, 
  BProgress, 
  BCardText, 
  BDropdown, 
  BDropdownItem 
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import * as Services from './services'
export default {
    components: {
        BLink, 
        BImg, 
        BContainer, 
        BRow, 
        BCol, 
        BCard, 
        BFormGroup, 
        BButton, 
        BProgress, 
        BCardText, 
        BDropdown, 
        BDropdownItem,

        flatPickr
    },
    setup() {
        const { dateFrom: from, dateTo: to, resetDate } = Services
        return {
            from,
            to,
            resetDate
        }
    },
    watch: {

    }
}
</script>

<style>

</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>